import React from "react";
import { Container, Text, Title, Paper, Button } from "@mantine/core";
import { Link } from "wouter";
import { Trans, useTranslation } from "react-i18next";

const PaymentCancelled = () => {
  const { t } = useTranslation("common");

  return (
    <Container size="xs" ta="center">
      <Paper mt="xl" p="lg" withBorder>
        <Title mb="xl" order={2}>
          {t("payment.cancelled.title")}
        </Title>
        <Text>{t("payment.cancelled.body")}</Text>
        <Text mt="xl">
          <Trans
            i18nKey="payment.cancelled.support"
            components={[<a key="0" href="mailto:support@facetflux.com" />]}
          />
        </Text>
        <Button mt="xl" component={Link} to="/settings/tenant">
          {t("payment.cancelled.backToProfile")}
        </Button>
      </Paper>
    </Container>
  );
};

export default PaymentCancelled;
